export const recommendedLeagues = [
  // England
  8, // Premier league
  70, // Championship,
  15, // League one,
  32, // League two
  95, // League Cup
  // Spain
  7, // Primera divion
  138, // Copa del ray
  // Italy
  13, // Serie a,
  14, // Serie B
  // Netherlands
  1, // Eredivisie
  103, // Cup
  // Germany
  9, // Bundesliga
  11, // 2. Bundesliga
  104, // Cup
  // France,
  16, // League 1,
  17, // League 2
  // Norway
  29, // eliteserien
  36, // 1. div
  182, // Cup
  // Sweden
  28, // Allsvenskan
  37, // Superettan
  // Denmark
  30, // Superliga
  181, // Cup
  // Brazil
  26, // Serie A
  // Belgium
  24, // Pro league
  126, // cup
  // Austria
  49, // Bundesliga
  // Argentina
  87, // Primera Division
  // Finland
  22, // Elite series
  // Greece
  107, // Superleague
  // Poland
  120, // 1. Liga
  // Portugal
  63, // Primeira liga
  640, // Cup
  // Russia
  121, // Premier League
  // Scotland
  43, // Premier League,
  45, // Championship
  176, // Cup
  // Switzerland
  27, // Super league
  // Turkey
  19, // Super liga
  // USA
  33, // MLS
  // International
  10, // Champions League
  1000, // Euro qualifier
  18, // Europa League
  385, // Africa Cup of nations

  // American Football
  500001, // NFL

  // Baseball
  400001, // MLB

  // Basket
  300013, // NBA

  25, // Euro Championship
  224 // WC European Qualifiers
]



/** WEBPACK FOOTER **
 ** ./src/config/recommendedLeagues.js
 **/